const pjson = require('../package.json')

const globalConfig = {
    mode: process.env.VUE_APP_MODE,
    project: process.env.VUE_APP_PROJECT,
    appVersion: pjson.version,
    googleMapsApiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    amplitude: process.env.VUE_APP_AMPLITUDE,
    smsToken: process.env.VUE_APP_SMS_TOKEN,
    firebaseConfig: {
        apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
        projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_FIREBASE_APP_ID,
        measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
    },
}

export {
    globalConfig,
}
